const actions = {
  SEARCH_REQUEST: "FACILITY_CREDENTIAL/SEARCH_REQUEST",
  SEARCH_SUCCESS: "FACILITY_CREDENTIAL/SEARCH_SUCCESS",
  SEARCH_ERROR: "FACILITY_CREDENTIAL/SEARCH_ERROR",

  DETAIL_REQUEST: "FACILITY_CREDENTIAL/DETAIL_REQUEST",
  DETAIL_SUCCESS: "FACILITY_CREDENTIAL/DETAIL_SUCCESS",
  DETAIL_ERROR: "FACILITY_CREDENTIAL/DETAIL_ERROR",
  RESET_DETAIL: "FACILITY_CREDENTIAL/RESET_DETAIL",

  CREATE_REQUEST: "FACILITY_CREDENTIAL/CREATE_REQUEST",
  CREATE_SUCCESS: "FACILITY_CREDENTIAL/CREATE_SUCCESS",
  CREATE_ERROR: "FACILITY_CREDENTIAL/CREATE_ERROR",

  UPDATE_REQUEST: "FACILITY_CREDENTIAL/UPDATE_REQUEST",
  UPDATE_SUCCESS: "FACILITY_CREDENTIAL/UPDATE_SUCCESS",
  UPDATE_ERROR: "FACILITY_CREDENTIAL/UPDATE_ERROR",

  DELETE_REQUEST: "FACILITY_CREDENTIAL/DELETE_REQUEST",
  DELETE_SUCCESS: "FACILITY_CREDENTIAL/DELETE_SUCCESS",
  DELETE_ERROR: "FACILITY_CREDENTIAL/DELETE_ERROR",

  search: (payload) => ({ type: actions.SEARCH_REQUEST, payload }),
  getDetail: (payload) => ({ type: actions.DETAIL_REQUEST, payload }),
  create: (payload) => ({ type: actions.CREATE_REQUEST, payload }),
  update: (payload) => ({ type: actions.UPDATE_REQUEST, payload }),
  delete: (payload) => ({ type: actions.DELETE_REQUEST, payload }),
  resetDetail: () => ({ type: actions.RESET_DETAIL }),
};

export default actions;
